import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { CoreMenuItem } from '@core/types';

@Component({
	selector: '[core-menu-vertical-section]',
	templateUrl: './section.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class CoreMenuVerticalSectionComponent {
	@Input()
	item: CoreMenuItem;
}
